import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { useNavigate } from 'react-router-dom';
import { Button, CenteredCard, Input, Logo, Notice } from '../components/ui';
import { colors, type, heading } from '../theme';

export default function ResetPassword() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);

    if (error) {
      setError(error.message);
    } else {
      setSuccess(true);
      setTimeout(() => navigate('/'), 2000);
    }
  }

  return (
    <CenteredCard width="380px">
      <Logo variant="horizontal" size={26} style={{ marginBottom: '24px' }} />
      <h1 style={{ ...heading.display, marginBottom: '4px' }}>Reset password</h1>
      <p style={{ fontSize: type.md, color: colors.textMuted, marginBottom: '20px' }}>
        Choose a new password for your account.
      </p>
      {success ? (
        <Notice tone="success">Password updated. Redirecting…</Notice>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <Input
            type="password"
            placeholder="New password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ height: '36px' }}
            autoFocus
          />
          <Input
            type="password"
            placeholder="Confirm password"
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
            style={{ height: '36px' }}
          />
          {error && <Notice tone="danger">{error}</Notice>}
          <Button type="submit" variant="primary" size="lg" block disabled={loading} style={{ marginTop: '4px' }}>
            {loading ? 'Updating…' : 'Update password'}
          </Button>
        </form>
      )}
    </CenteredCard>
  );
}
